// Axios instance for the TEAMM8 Wholesale API. `withCredentials` sends the httpOnly auth cookies.
// A response interceptor transparently refreshes an expired access token once, then retries.
import axios from 'axios';

export const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

// Registered by the auth store so the interceptor can drop the app to a logged-out state when
// a refresh definitively fails (avoids a circular import between this module and the store).
let onSessionExpired = null;
export function registerSessionExpiredHandler(fn) {
  onSessionExpired = fn;
}

let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || '';
    const isRefreshCall = url.includes('/auth/refresh');

    if (status === 401 && original && !original.__retried && !isRefreshCall) {
      original.__retried = true;
      try {
        refreshPromise = refreshPromise || api.post('/auth/refresh');
        await refreshPromise;
        return api(original);
      } catch (refreshError) {
        onSessionExpired?.();
        return Promise.reject(refreshError);
      } finally {
        refreshPromise = null;
      }
    }

    return Promise.reject(error);
  }
);
